import RegisterPasien from "../../components/RegisterPasien/HomePagePasienOnlineProfile";

export default function Register() {
  return (
    <div style={{backgroundColor:"white"}}>
      <RegisterPasien/>
    </div>
  );
}
